var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown-editor',{ref:"editor",attrs:{"configs":_vm.options,"name":_vm.name},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }